<template>
  <div class="l-row">
    <form-group :label="`${$t('category.label')} ${$t('level.label')} ${(index + 1)}`" :columns="columns" v-for="(level, index) in levels" :key="index">
      <select class="form-select" :value="selectedId(index)" @change="onChange(index, $event.target.value)">
        <option :value="null">{{ $t('choose.label') }}</option>
        <option v-for="category in level" :key="category.id" :value="category.id">{{ category.name }}</option>
      </select>
    </form-group>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      tree: [],
      path: [],
      account: null
    }),
    props: {
      columns: {
        type: Number,
        default: 6
      }
    },
    computed: {
      levels () {
        const levels = [this.tree]

        for (const category of this.path) {
          if (!category.children.length) {
            break
          }

          levels.push(category.children)
        }

        return levels
      }
    },
    async mounted () {
      this.$emit('loading', true)

      try {
        const accounts = await api.shein.getAccounts({ options: { active: true } })

        if (!accounts.total) {
          notifier.error('Você precisa pelo menos ter uma conta ativa para fazer uma predefinição!', 'Conta')
          return
        }

        this.account = accounts.items[0]
        this.$emit('account', this.account)

        const raw = await api.shein.getCategories(this.account.identifier)
        const data = Array.isArray(raw) ? raw : (raw && raw.data ? raw.data : [])
        this.tree = data.map(node => this.normalize(node)).filter(Boolean)
      } catch (err) {
        notifier.error('Impossível carregar as categorias da Shein.', 'Erro')
      } finally {
        this.$emit('loading', false)
      }
    },
    methods: {
      normalize (node) {
        if (!node) {
          return null
        }

        return {
          id: node.category_id || node.id,
          name: node.category_name || node.name,
          product_type_id: node.product_type_id,
          last_category: node.last_category === true,
          children: (node.children || []).map(child => this.normalize(child)).filter(Boolean)
        }
      },
      selectedId (index) {
        return this.path[index] ? this.path[index].id : null
      },
      onChange (index, rawId) {
        this.path.splice(index)

        const category = this.levels[index].find(item => String(item.id) === String(rawId))

        if (category) {
          this.path.push(category)
        }

        this.$emit('change', this.path.map(({ id, name, product_type_id, last_category }) => ({ id, name, product_type_id, last_category })))
      },
      reset () {
        this.path = []
        this.$emit('change', [])
      }
    },
    components: {
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// CategoryCascade.vue?f54b7604